import type { IAmbassadorClient } from '~/@api/generated-api-types-ambassador/Api'
import { DetailTable } from './DetailTable'

type Props = {
  clients: Array<IAmbassadorClient>
  isLoading: boolean
}

export function ClientsSection({ clients, isLoading }: Props) {
  return (
    <div className="flex flex-col gap-4">
      <h4 className="text-base font-bold text-primary">Zoznam klientov</h4>
      <DetailTable clients={clients} isLoading={isLoading} />
    </div>
  )
}
